(function () {
  'use strict';

  var root = document.getElementById('product-base-sensor');
  if (!root) return;

  var moneyFormat = window.Shopify && Shopify.money_format ? Shopify.money_format : '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  var variantsJSON = root.querySelector('[data-product-sensor-variants]');
  var variants = [];
  try {
    variants = variantsJSON ? JSON.parse(variantsJSON.textContent) : [];
  } catch (e) {
    variants = [];
  }

  var form = root.querySelector('[data-product-sensor-form]');
  var variantIdInput = root.querySelector('[data-product-sensor-variant-id]');
  var optionSelects = root.querySelectorAll('[data-product-sensor-option]');
  var priceSaleEl = root.querySelector('[data-product-sensor-price-sale]');
  var priceCompareEl = root.querySelector('[data-product-sensor-price-compare]');
  var submitBtn = root.querySelector('[data-product-sensor-submit]');
  var submitText = root.querySelector('[data-product-sensor-submit-text]');
  var soldOutNote = root.querySelector('[data-product-sensor-sold-out-note]');
  var successNote = root.querySelector('[data-product-sensor-success-note]');
  var errorNote = root.querySelector('[data-product-sensor-error-note]');
  var qtyInput = root.querySelector('[data-product-sensor-qty-input]');
  var qtyDecrease = root.querySelector('[data-product-sensor-qty-decrease]');
  var qtyIncrease = root.querySelector('[data-product-sensor-qty-increase]');

  function findVariantBySelectedOptions() {
    var selected = [];
    optionSelects.forEach(function (select) {
      selected[Number(select.dataset.optionIndex)] = select.value;
    });

    return variants.filter(function (variant) {
      return selected.every(function (value, index) {
        return variant.options[index] === value;
      });
    })[0];
  }

  function setActiveVariant(variant) {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceSaleEl) priceSaleEl.textContent = formatMoney(variant.price);

    if (priceCompareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceCompareEl.textContent = formatMoney(variant.compare_at_price);
        priceCompareEl.hidden = false;
      } else {
        priceCompareEl.hidden = true;
      }
    }

    if (variant.featured_image && variant.featured_image.id) {
      var mainImage = root.querySelector(
        '[data-product-sensor-main-image][data-image-id="' + variant.featured_image.id + '"]'
      );
      if (mainImage) showMainImage(mainImage.dataset.imageId);
    }

    if (submitBtn) submitBtn.disabled = !variant.available;
    if (submitText) submitText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    if (soldOutNote) soldOutNote.hidden = !!variant.available;
  }

  optionSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      var variant = findVariantBySelectedOptions();
      setActiveVariant(variant);
    });
  });

  function showMainImage(imageId) {
    root.querySelectorAll('[data-product-sensor-main-image]').forEach(function (img) {
      var isMatch = img.dataset.imageId === imageId;
      img.hidden = !isMatch;
      img.classList.toggle('product-base-sensor__gallery-main-image--active', isMatch);
    });

    root.querySelectorAll('[data-product-sensor-thumb]').forEach(function (thumb) {
      thumb.classList.toggle(
        'product-base-sensor__gallery-thumb--active',
        thumb.dataset.imageId === imageId
      );
    });
  }

  root.querySelectorAll('[data-product-sensor-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showMainImage(thumb.dataset.imageId);
    });
  });

  function clampQuantity(value) {
    var qty = parseInt(value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    return qty;
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      qtyInput.value = clampQuantity(qtyInput.value);
    });
  }

  if (qtyDecrease && qtyInput) {
    qtyDecrease.addEventListener('click', function () {
      qtyInput.value = clampQuantity(qtyInput.value) - 1 < 1 ? 1 : clampQuantity(qtyInput.value) - 1;
    });
  }

  if (qtyIncrease && qtyInput) {
    qtyIncrease.addEventListener('click', function () {
      qtyInput.value = clampQuantity(qtyInput.value) + 1;
    });
  }

  function updateCartCountBadges(itemCount) {
    document.querySelectorAll('[data-site-header-controls-cart-count], [data-menu-cart-count]').forEach(
      function (el) {
        el.textContent = itemCount;
      }
    );
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (submitBtn) submitBtn.disabled = true;
      if (submitBtn) submitBtn.classList.add('product-base-sensor__submit--loading');
      if (errorNote) {
        errorNote.hidden = true;
        errorNote.textContent = '';
      }
      if (successNote) successNote.hidden = true;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          if (successNote) successNote.hidden = false;
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (response) {
          return response && response.json ? response.json() : null;
        })
        .then(function (cart) {
          if (cart) updateCartCountBadges(cart.item_count);
        })
        .catch(function (error) {
          if (errorNote) {
            errorNote.textContent =
              (error && error.description) || 'Something went wrong adding this to your cart.';
            errorNote.hidden = false;
          }
        })
        .finally(function () {
          var variant = findVariantBySelectedOptions() || variants[0];
          if (submitBtn) submitBtn.disabled = variant ? !variant.available : false;
          if (submitBtn) submitBtn.classList.remove('product-base-sensor__submit--loading');
        });
    });
  }
})();
